export default {
  GET_SALES_CONSULTANTS: (state) => state.salesConsultants,
  GET_ACTIVE_SALES_CONSULTANTS: (state) =>
    state.salesConsultants.filter((salesConsultant) => salesConsultant.status),
  GET_SALES_CONSULTANT: (state) => state.salesConsultant,
};
